import productApiData from './productApiData.json';

const oldProductIDs = {
  'REL-49-01': {
    dev: '116',
    stage: '111',
    beta: '115',
    prod: '115',
  },
  'REL-60-01': {
    dev: '115',
    stage: '110',
    beta: '116',
    prod: '116',
  },
  'ENR-60-01': {
    dev: '114',
    stage: '112',
    beta: '118',
    prod: '118',
  },
  'CLM-60-01': {
    dev: '113',
    stage: '113',
    beta: '117',
    prod: '117',
  },
  'SLP-60-01': {
    dev: '118',
    stage: '116',
    beta: '119',
    prod: '119',
  },
};

const newProductIDs = {
  'REL-60-02': {
    dev: '120',
    stage: '121',
    beta: '121',
    prod: '121',
  },
  'REL-60-03': {
    dev: '121',
    stage: '122',
    beta: '122',
    prod: '122',
  },
  'TNK-60-01': {
    dev: '152',
    stage: '152',
    beta: '152',
    prod: '136',
  },
  'GOF-60-01': {
    dev: '126',
    stage: '126',
    beta: '126',
    prod: '126',
  },
  'ZEN-60-01': {
    dev: '123',
    stage: '127',
    beta: '127',
    prod: '123',
  },
  'ZEN-60-02': {
    dev: '124',
    stage: '128',
    beta: '128',
    prod: '124',
  },
  'ZFA-60-01': {
    dev: '127',
    stage: '123',
    beta: '123',
    prod: '125',
  },
  'FREE_VITD': {
    dev: '98',
    stage: '75',
    beta: '75',
    prod: '75',
  },
  'FREE_VITC': {
    dev: '75',
    stage: '98',
    beta: '98',
    prod: '98',
  },
  'REL-60-04': {
    dev: '145',
    stage: '150',
    beta: '150',
    prod: '134', // Need to Update Production ID
  },
  'REL-60-05': {
    dev: '146',
    stage: '151',
    beta: '151',
    prod: '135', // Need to Update Production ID
  },
  'ACB-120-01': {
    dev: '135',
    stage: '138',
    beta: '123',
    prod: '137',
  },
  'FSE-120-01': {
    dev: '136',
    stage: '139',
    beta: '',
    prod: '138',
  },
  'IMF-120-01': {
    dev: '137',
    stage: '140',
    beta: '',
    prod: '139',
  },
  'NAC-120-01': {
    dev: '138',
    stage: '141',
    beta: '',
    prod: '140',
  },
  'BER-60-01': {
    dev: '139',
    stage: '142',
    beta: '',
    prod: '141',
  },
  'VBC-120-01': {
    dev: '140',
    stage: '143',
    beta: '',
    prod: '142',
  },
  'RYR-120-01': {
    dev: '141',
    stage: '144',
    beta: '',
    prod: '143',
  },
  'VEP-60-01': {
    dev: '142',
    stage: '145',
    beta: '',
    prod: '144',
  },

  'DK2-120-01': {
    dev: '143',
    stage: '146',
    beta: '',
    prod: '145',
  },
  'DK5-120-01': {
    dev: '144',
    stage: '147',
    beta: '',
    prod: '146',
  },
};

const mappedProductIDs = {
  ...oldProductIDs,
  ...newProductIDs,
};

const RF_QUICKSTART = 'REL-01';
const RF_60CT = 'REL-02';
const RF_60CT_SINGLE = 'REL-03';
const RF_ENERGY1 = 'ENR-01';
const RF_ENERGY2 = 'ENR-02';
const RF_ENERGY3 = 'ENR-03';
const RF_CALM = 'CLM-01';
const RF_SLEEP = 'SLP-01';
const RF_RELIEF_FACTOR_QS = 'REL-04';
const RF_RELIEF_FACTOR_60_CT = 'REL-05';
const RF_RELIEF_FACTOR_60_CT_CA = 'REL-06';
const RF_RELIEF_FACTOR_60_CT_SINGLE = 'REL-07';
const RF_RELIEF_FACTOR_60_CT_CA_SINGLE = 'REL-08';
const RF_THINK_FACTOR = 'TNK-01';
const RF_THINK_FACTOR_SINGLE = 'TNK-02';
const RF_GO_FACTOR = 'GOF-01';
const RF_GO_FACTOR_SINGLE = 'GOF-02';
const RF_ZEN_FACTOR = 'ZEN-01';
const RF_ZEN_FACTOR_CA = 'ZEN-02';
const RF_ZEN_FACTOR_SINGLE = 'ZEN-03';
const RF_ZEN_FACTOR_CA_SINGLE = 'ZEN-04';
const RF_Z_FACTOR = 'ZFA-01';
const RF_Z_FACTOR_SINGLE = 'ZFA-02';
const DE_ANTIOXIDANTS = 'ACB-01';
const DE_ANTIOXIDANTS_SINGLE = 'ACB-02';
const RF_FULL_SPECTRUM_E = 'FSE-01';
const RF_FULL_SPECTRUM_E_SINGLE = 'FSE-02';
const RF_IMMUNE_FACTOR = 'IMF-01';
const RF_IMMUNE_FACTOR_SINGLE = 'IMF-02';
const RF_N_ACETYL_CYSTEINE = 'NAC-01';
const RF_N_ACETYL_CYSTEINE_SINGLE = 'NAC-02';
const RF_BERBERINE = 'BER-01';
const RF_BERBERINE_SINGLE = 'BER-02';
const RF_VITAMIN_B_COMPLEX = 'VBC-01';
const RF_VITAMIN_B_COMPLEX_SINGLE = 'VBC-02';
const RF_RED_YEAST_RICE = 'RY-01';
const RF_RED_YEAST_RICE_SINGLE = 'RY-02';
const RF_VESSEL_PROTECTION = 'VEP-01';
const RF_VESSEL_PROTECTION_SINGLE = 'VEP-02';
const RF_VITAMIN_D_K2 = 'DK2-01';
const RF_VITAMIN_D_K2_SINGLE = 'DK2-02';
const RF_VITAMIN_D_K5 = 'DK5-01';
const RF_VITAMIN_D_K5_SINGLE = 'DK5-02';
const RF_RELIEF_FACTOR_QS_NEC = 'REL-09';
const RF_RELIEF_FACTOR_QS_NEC_SINGLE = 'REL-11';
const RF_RELIEF_FACTOR_60_CT_NEC = 'REL-10';

export const oldProductsKeyConstants = {
  RF_QUICKSTART,
  RF_60CT,
  RF_60CT_SINGLE,
  RF_ENERGY1,
  RF_ENERGY2,
  RF_ENERGY3,
  RF_CALM,
  RF_SLEEP,
};

export const newProductsKeyConstants = {
  RF_RELIEF_FACTOR_QS,
  RF_RELIEF_FACTOR_60_CT,
  RF_RELIEF_FACTOR_60_CT_CA,
  RF_RELIEF_FACTOR_60_CT_SINGLE,
  RF_RELIEF_FACTOR_60_CT_CA_SINGLE,
  RF_GO_FACTOR,
  RF_GO_FACTOR_SINGLE,
  RF_ZEN_FACTOR,
  RF_ZEN_FACTOR_CA,
  RF_ZEN_FACTOR_SINGLE,
  RF_ZEN_FACTOR_CA_SINGLE,
  RF_Z_FACTOR,
  RF_Z_FACTOR_SINGLE,
  RF_THINK_FACTOR,
  RF_THINK_FACTOR_SINGLE,
  DE_ANTIOXIDANTS,
  DE_ANTIOXIDANTS_SINGLE,
  RF_FULL_SPECTRUM_E,
  RF_FULL_SPECTRUM_E_SINGLE,
  RF_IMMUNE_FACTOR,
  RF_IMMUNE_FACTOR_SINGLE,
  RF_N_ACETYL_CYSTEINE,
  RF_N_ACETYL_CYSTEINE_SINGLE,
  RF_BERBERINE,
  RF_BERBERINE_SINGLE,
  RF_VITAMIN_B_COMPLEX,
  RF_VITAMIN_B_COMPLEX_SINGLE,
  RF_RED_YEAST_RICE,
  RF_RED_YEAST_RICE_SINGLE,
  RF_VESSEL_PROTECTION,
  RF_VESSEL_PROTECTION_SINGLE,
  RF_VITAMIN_D_K2,
  RF_VITAMIN_D_K2_SINGLE,
  RF_VITAMIN_D_K5,
  RF_VITAMIN_D_K5_SINGLE,
  RF_RELIEF_FACTOR_QS_NEC,
  RF_RELIEF_FACTOR_QS_NEC_SINGLE,
  RF_RELIEF_FACTOR_60_CT_NEC,
};

const productsKeyConstants = {
  ...oldProductsKeyConstants,
  ...newProductsKeyConstants,
};
const ProductsCategory = {
  RELIEF_FACTOR: 'REL',
  GO_FACTOR: 'GOF',
  ZEN_FACTOR: 'ZEN',
  Z_FACTOR: 'ZFA',
  ANTIOXIDANTS: 'ACB',
  FULL_SPECTRUM_E: 'FSE',
  IMMUNE_FACTOR: 'IMF',
  N_ACETYL_CYSTEINE: 'NAC',
  BERBERINE: 'BER',
  VITAMIN_B_COMPLEX: 'VBC',
  RED_YEAST_RICE: 'RYR',
  VESSEL_PROTECTION: 'VEP',
  VITAMIN_D_K2: 'DK2',
  VITAMIN_D_K5: 'DK5',
  THINK_FACTOR: 'TNK',
};

export const productMappedCategory = {
  REL: 'Pain Relief',
  TNK: 'Cognition Support',
  GOF: 'Energy Boost',
  ZEN: 'Anxiety Relief',
  ZFA: 'Sleep Support',
  ACB: 'Antioxidants with Vitamin C & Bioflavonoids',
  FSE: 'Full Spectrum E',
  IMF: 'Immune Factors',
  NAC: 'NAC N-Acetyl L-Cysteine',
  BER: 'Berberine',
  VBC: 'Vitamin B Complex',
  RYR: 'Red Yeast Rice with CoQ10',
  VEP: 'Vessel Protection',
  DK2: 'Vitamin D3 and K-2 2000 IU',
  DK5: 'Vitamin D3 and K-2 5000 IU',
  DAE: 'Daily Essentials',
};
export const productUpgradeMapping = {
  [RF_RELIEF_FACTOR_60_CT_SINGLE]: {
    key: RF_RELIEF_FACTOR_QS,
    isSubscription: true,
    category: 'REL',
    quantity: 1,
  },
  [RF_GO_FACTOR_SINGLE]: {
    key: RF_GO_FACTOR,
    isSubscription: true,
    category: 'GOF',
    quantity: 1,
  },
  [RF_ZEN_FACTOR_SINGLE]: {
    key: RF_ZEN_FACTOR,
    isSubscription: true,
    category: 'ZEN',
    quantity: 1,
  },
  [RF_Z_FACTOR_SINGLE]: {
    key: RF_Z_FACTOR,
    isSubscription: true,
    category: 'ZFA',
    quantity: 1,
  },
  [RF_THINK_FACTOR_SINGLE]: {
    key: RF_THINK_FACTOR,
    isSubscription: true,
    category: 'TNK',
    quantity: 1,
  },
  [DE_ANTIOXIDANTS_SINGLE]: {
    key: DE_ANTIOXIDANTS,
    isSubscription: true,
    category: 'ACB',
    quantity: 1,
  },
  [RF_FULL_SPECTRUM_E_SINGLE]: {
    key: RF_FULL_SPECTRUM_E,
    isSubscription: true,
    category: 'FSE',
    quantity: 1,
  },
  [RF_IMMUNE_FACTOR_SINGLE]: {
    key: RF_IMMUNE_FACTOR,
    isSubscription: true,
    category: 'IMF',
    quantity: 1,
  },
  [RF_N_ACETYL_CYSTEINE_SINGLE]: {
    key: RF_N_ACETYL_CYSTEINE,
    isSubscription: true,
    category: 'NAC',
    quantity: 1,
  },
  [RF_BERBERINE_SINGLE]: {
    key: RF_BERBERINE,
    isSubscription: true,
    category: 'BER',
    quantity: 1,
  },
  [RF_VITAMIN_B_COMPLEX_SINGLE]: {
    key: RF_VITAMIN_B_COMPLEX,
    isSubscription: true,
    category: 'VBC',
    quantity: 1,
  },
  [RF_RED_YEAST_RICE_SINGLE]: {
    key: RF_RED_YEAST_RICE,
    isSubscription: true,
    category: 'RYR',
    quantity: 1,
  },
  [RF_VESSEL_PROTECTION_SINGLE]: {
    key: RF_VESSEL_PROTECTION,
    isSubscription: true,
    category: 'VEP',
    quantity: 1,
  },
  [RF_VITAMIN_D_K2_SINGLE]: {
    key: RF_VITAMIN_D_K2,
    isSubscription: true,
    category: 'DK2',
    quantity: 1,
  },
  [RF_VITAMIN_D_K5_SINGLE]: {
    key: RF_VITAMIN_D_K5,
    isSubscription: true,
    category: 'DK5',
    quantity: 1,
  },
  [RF_RELIEF_FACTOR_QS_NEC_SINGLE]: {
    key: RF_RELIEF_FACTOR_QS_NEC,
    isSubscription: true,
    category: 'REL',
    quantity: 1,
  },
  [RF_RELIEF_FACTOR_60_CT_NEC]: {
    key: RF_RELIEF_FACTOR_QS_NEC,
    isSubscription: true,
    category: 'REL',
    quantity: 1,
  },
};

let dbMapping = {
  dev: 'dev',
  develop: 'dev',
  development: 'dev',
  stage: 'stage',
  staging: 'stage',
  beta: 'beta',
  production: 'prod',
  prod: 'prod',
};

let db = dbMapping[process.env.NEXT_PUBLIC_DB_ENV] || 'dev';

export const productAffiliateMapping = {
  ['rfqs']: '/products/relief-factor',
  ['rfct60']: '/products/relief-factor',
  ['rfgof']: '/products/go-factor',
  ['rfzen']: '/products/zen-factor',
  ['rfzfa']: '/products/z-factor',
};

export const oldProducts = {
  [RF_QUICKSTART]: {
    key: RF_QUICKSTART,
    category: 'REL',
    disclaimer:
      "For your convenience, your purchase of QuickStart is followed by a full month's supply (60 packets) of Relief Factor shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    initialPrice: '19.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
    name: '3-Week QuickStart',
    sku: 'REL-49-01',
    productId: mappedProductIDs['REL-49-01'][db],
    productName: 'Relief Factor 3-Week QuickStart',
    quoteParams: {
      productId: mappedProductIDs['REL-49-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'd8210b55-0465-46ea-a843-831c03a57ab2',
      triggerType: '2',
      //      existingItemsOffer: [],
    },
    recurringPrice: '79.95',
  },
  [RF_60CT]: {
    key: RF_60CT,
    category: 'REL',
    disclaimer:
      'For your convenience, when you purchase Relief Factor Initial 60 Pack at the Subscribe & Save price, your next order will be shipped in one month and then every month thereafter until you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <span>833-888-1533</span> or send an email to <a href="mailto:contactus@relieffactor.com">contactus@relieffactor.com</a> at least 1 day before your next supply ships.',
    initialPrice: '79.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rf60-wfree_1_3.png',
    name: '60-ct Bag',
    sku: 'REL-60-01',
    productId: mappedProductIDs['REL-60-01'][db],
    productName: 'Relief Factor 60 Pack',
    quoteParams: {
      productId: mappedProductIDs['REL-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'f693de48-4b3f-4a20-9c65-19f5111e9734',
      triggerType: '3',
      //      existingItemsOffer: [],
    },
    recurringPrice: '79.95',
  },
  [RF_60CT_SINGLE]: {
    key: RF_60CT_SINGLE,
    category: 'REL',
    disclaimer: '',
    initialPrice: '93.95',
    isSubscription: false,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rf60-front_1_3.png',
    name: '60-ct Bag',
    sku: 'REL-60-01',
    productId: mappedProductIDs['REL-60-01'][db],
    productName: 'Relief Factor 60 Pack',
    quoteParams: {
      productId: mappedProductIDs['REL-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'f693de48-4b3f-4a20-9c65-19f5111e9734',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '0.00',
  },
  [RF_ENERGY1]: {
    key: RF_ENERGY1,
    category: 'ENR',
    disclaimer:
      "When you purchase Go Factor you will automatically receive the regular 60-capsules supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    initialPrice: '34.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/e/n/energy-pills-single_10.png',
    name: '1 Bottle',
    sku: 'ENR-60-01',
    productId: mappedProductIDs['ENR-60-01'][db],
    productName: 'Go Factor (60-capsules)',
    quoteParams: {
      productId: mappedProductIDs['ENR-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '61cb60a9-3f56-4cfd-8b11-69a2ff790441',
      offerId: '8f1b2495-7f54-4aef-bf07-a7afd18f5aaf',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '29.95',
  },
  [RF_ENERGY2]: {
    key: RF_ENERGY2,
    category: 'ENR',
    disclaimer:
      "When you purchase Go Factor you will automatically receive the regular 180-capsules supply shipped in 90 days and then monthly thereafter unless you cancel. Your card will be charged $24.85 + applicable state taxes each time your supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    initialPrice: '29.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/e/n/energy-pills-three_5.png',
    name: '3 Bottles',
    sku: 'ENR-60-01',
    productId: mappedProductIDs['ENR-60-01'][db],
    productName: 'Go Factor (60-capsules)',
    quoteParams: {
      productId: mappedProductIDs['ENR-60-01'][db],
      //customerId: '',
      quantity: 3,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '61cb60a9-3f56-4cfd-8b11-69a2ff790441',
      offerId: '7b8763a1-9acc-45e1-ae20-5cb8be777e93',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '24.85',
  },
  [RF_ENERGY3]: {
    key: RF_ENERGY3,
    category: 'ENR',
    disclaimer:
      'When you purchase Go Factor you will automatically receive the regular 360-capsules supply shipped in 180 days and then monthly thereafter unless you cancel. Your card will be charged $19.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href="mailto:contactus@relieffactor.com">contactus@relieffactor.com</a> at least 1 day before your next supply ships.',
    initialPrice: '24.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/e/n/energy-pills-six_4.png',
    name: '6 Bottles',
    sku: 'ENR-60-01',
    productId: mappedProductIDs['ENR-60-01'][db],
    productName: 'Go Factor (60-capsules)',
    quoteParams: {
      productId: mappedProductIDs['ENR-60-01'][db],
      //customerId: '',
      quantity: 6,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '61cb60a9-3f56-4cfd-8b11-69a2ff790441',
      offerId: '9db1923d-5d38-424a-a93c-25a3fbaac4c5',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '19.95',
  },
  [RF_CALM]: {
    key: RF_CALM,
    category: 'CLM',
    disclaimer: `When you purchase Zen Factor you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a>
     or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    initialPrice: '28.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfcalm_8.png',
    name: 'Zen Factor (60 count)',
    sku: 'CLM-60-01',
    productId: mappedProductIDs['CLM-60-01'][db],
    productName: 'Zen Factor (60 count)',
    quoteParams: {
      productId: mappedProductIDs['CLM-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: 'b5e92d67-92c8-4d8d-9f35-be925b99633f',
      offerId: '6c546628-6435-4490-8675-4097e4f87f52',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '21.95',
  },
  [RF_SLEEP]: {
    key: RF_SLEEP,
    category: 'SLP',
    disclaimer: `When you purchase Z Factor you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    initialPrice: '19.95',
    isSubscription: true,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rf-sleep-500.png',
    name: 'Z Factor (60 count)',
    sku: 'SLP-60-01',
    productId: mappedProductIDs['SLP-60-01'][db],
    productName: 'Z Factor (60 count)',
    quoteParams: {
      productId: mappedProductIDs['SLP-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '11d07b11-0cd4-45be-b42e-4285f2d5b4a7',
      offerId: 'f95176e3-5730-4ae2-83ce-c4e5a1038b1f',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    recurringPrice: '29.95',
  },
};

export const newProducts = {
  [RF_RELIEF_FACTOR_QS]: {
    key: RF_RELIEF_FACTOR_QS,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '19.95',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-02',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['REL-60-02'][db],
    CA_sku: 'REL-60-03',
    CA_product_id: mappedProductIDs['REL-60-03'][db],
    free_products: [
      {
        sku: 'FREE_VITD',
        name: 'Vitamin D3',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitd.jpg',
        productId: mappedProductIDs['FREE_VITD'][db],
        dsc: '30 softgels',
      },
      {
        sku: 'FREE_VITC',
        name: 'Vitamin C',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitc.jpg',
        productId: mappedProductIDs['FREE_VITC'][db],
        dsc: '30 tablets',
      },
    ],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['REL-60-02'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: '0a9a4a04-20bb-4654-afd4-843dc4ebcade',
      triggerType: '3', // Need to check before going to Production
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_RELIEF_FACTOR_60_CT]: {
    key: RF_RELIEF_FACTOR_60_CT,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-02',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['REL-60-02'][db],
    CA_sku: 'REL-60-03',
    CA_product_id: mappedProductIDs['REL-60-03'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['REL-60-02'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: '69d332a4-29b1-41db-b8a7-45ab30796cb6',
      triggerType: 3,
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_RELIEF_FACTOR_60_CT_SINGLE]: {
    key: RF_RELIEF_FACTOR_60_CT_SINGLE,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: false,
    displayPrice: 93.95,
    initialPrice: '0.00',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-02',
    productId: mappedProductIDs['REL-60-02'][db],
    CA_sku: 'REL-60-03',
    CA_product_id: mappedProductIDs['REL-60-03'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['REL-60-02'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: '69d332a4-29b1-41db-b8a7-45ab30796cb6',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_THINK_FACTOR]: {
    key: RF_THINK_FACTOR,
    title: 'Think Factor',
    name: 'Think Factor (60 count)',
    productName: 'Think Factor (60 count)',
    category: 'TNK',
    isSubscription: true,
    displayPrice: 0.0,
    initialPrice: '0.00',
    recurringPrice: '37.95',
    single_price: '44.94',
    sku: 'TNK-60-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['TNK-60-01'][db],
    free_products: [
      {
        sku: 'FREE_VITD',
        name: 'Vitamin D3',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitd.jpg',
        productId: mappedProductIDs['FREE_VITD'][db],
        dsc: '30 softgels',
      },
      {
        sku: 'FREE_VITC',
        name: 'Vitamin C',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitc.jpg',
        productId: mappedProductIDs['FREE_VITC'][db],
        dsc: '30 tablets',
      },
    ],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['TNK-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '3e7f9c2d-8b45-4a1e-bd72-f06a3c9e5d8a',
      offerId: 'f9d3a7b2-5c8e-41fd-9e3a-7a4c2d6b8f01',
      triggerType: '3', // Need to check before going to Production
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Think Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $37.95 + applicable state taxes each time your supply ships.  To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_THINK_FACTOR_SINGLE]: {
    key: RF_THINK_FACTOR_SINGLE,
    title: 'Think Factor',
    name: 'Think Factor (60 count)',
    productName: 'Think Factor (60 count)',
    category: 'TNK',
    isSubscription: false,
    displayPrice: 0.0,
    initialPrice: '0.00',
    recurringPrice: '37.95',
    single_price: '44.95',
    sku: 'TNK-60-01',
    productId: mappedProductIDs['TNK-60-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['TNK-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '3e7f9c2d-8b45-4a1e-bd72-f06a3c9e5d8a',
      offerId: 'f9d3a7b2-5c8e-41fd-9e3a-7a4c2d6b8f01',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Think Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $37.95 + applicable state taxes each time your supply ships.  To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2beta.relieffactor.com/media/catalog/product/e/n/energy-pills-single.png',
  },
  [RF_GO_FACTOR]: {
    key: RF_GO_FACTOR,
    title: 'Go Factor',
    name: 'Go Factor (60 count)',
    productName: 'Go Factor (60 count)',
    category: 'GOF',
    isSubscription: true,
    displayPrice: 29.95,
    initialPrice: '0.00',
    recurringPrice: '29.95',
    single_price: '34.95',
    sku: 'GOF-60-01',
    isEligibleForSingleOrder: false,
    productId: mappedProductIDs['GOF-60-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['GOF-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '61cb60a9-3f56-4cfd-8b11-69a2ff790441',
      offerId: 'd5bca645-9f91-4d04-903f-d889656fb7bc',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer:
      'When you purchase <span>Go Factor</span> you will automatically receive the regular <span>60-capsules</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href="mailto:contactus@relieffactor.com">contactus@relieffactor.com</a> at least 1 day before your next supply ships.',
    imageUrl:
      'https://m2beta.relieffactor.com/media/catalog/product/e/n/energy-pills-single.png',
  },
  [RF_GO_FACTOR_SINGLE]: {
    key: RF_GO_FACTOR_SINGLE,
    title: 'Go Factor',
    name: 'Go Factor (60 count)',
    productName: 'Go Factor (60 count)',
    category: 'GOF',
    isSubscription: false,
    displayPrice: 34.95,
    initialPrice: '0.00',
    recurringPrice: '29.95',
    single_price: '34.95',
    sku: 'GOF-60-01',
    productId: mappedProductIDs['GOF-60-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['GOF-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '61cb60a9-3f56-4cfd-8b11-69a2ff790441',
      offerId: 'd5bca645-9f91-4d04-903f-d889656fb7bc',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer:
      'When you purchase <span>Go Factor</span> you will automatically receive the regular <span>60-capsules</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href="mailto:contactus@relieffactor.com">contactus@relieffactor.com</a> at least 1 day before your next supply ships.',
    imageUrl:
      'https://m2beta.relieffactor.com/media/catalog/product/e/n/energy-pills-single.png',
  },
  [RF_ZEN_FACTOR]: {
    key: RF_ZEN_FACTOR,
    title: 'Zen Factor',
    name: 'Zen Factor (60 count)',
    productName: 'Zen Factor (60 count)',
    category: 'ZEN',
    isSubscription: true,
    displayPrice: 21.95,
    initialPrice: '0.00',
    recurringPrice: '21.95',
    single_price: '28.95',
    sku: 'ZEN-60-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['ZEN-60-01'][db],
    CA_sku: 'ZEN-60-02',
    CA_product_id: mappedProductIDs['ZEN-60-02'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['ZEN-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: 'b5e92d67-92c8-4d8d-9f35-be925b99633f',
      offerId: '4a35194f-d1cb-4e59-a956-b1135961184f',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Zen Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a>
       or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2beta.relieffactor.com/media/catalog/product/r/f/rfcalm.png',
  },
  [RF_ZEN_FACTOR_SINGLE]: {
    key: RF_ZEN_FACTOR_SINGLE,
    title: 'Zen Factor',
    name: 'Zen Factor (60 count)',
    productName: 'Zen Factor (60 count)',
    category: 'ZEN',
    isSubscription: false,
    displayPrice: 28.95,
    initialPrice: '0.00',
    recurringPrice: '21.95',
    single_price: '28.95',
    sku: 'ZFA-60-01',
    productId: mappedProductIDs['ZEN-60-01'][db],
    CA_sku: 'ZEN-60-02',
    CA_product_id: mappedProductIDs['ZEN-60-02'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['ZEN-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: 'b5e92d67-92c8-4d8d-9f35-be925b99633f',
      offerId: '4a35194f-d1cb-4e59-a956-b1135961184f',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Zen Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a>
    or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2beta.relieffactor.com/media/catalog/product/r/f/rfcalm.png',
  },
  [RF_Z_FACTOR]: {
    key: RF_Z_FACTOR,
    title: 'Z Factor',
    name: 'Z Factor (60 count)',
    productName: 'Z Factor (60 count)',
    category: 'ZFA',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '19.95',
    recurringPrice: '29.95',
    single_price: '36.95',
    sku: 'ZFA-60-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['ZFA-60-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['ZFA-60-01'][db],
      //customerId: '',
      quantity: 1,
      planId: '11d07b11-0cd4-45be-b42e-4285f2d5b4a7',
      offerId: 'b80bb1fc-1fef-42a3-8432-90b1b429777a',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Z Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2stage.relieffactor.com/media/catalog/product/r/f/rf-sleep-500.png',
  },
  [RF_Z_FACTOR_SINGLE]: {
    key: RF_Z_FACTOR_SINGLE,
    title: 'Z Factor',
    name: 'Z Factor (60 count)',
    productName: 'Z Factor (60 count)',
    category: 'ZFA',
    isSubscription: false,
    displayPrice: 36.95,
    initialPrice: '19.95',
    recurringPrice: '29.95',
    single_price: '36.95',
    sku: 'ZFA-60-01',
    productId: mappedProductIDs['ZFA-60-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['ZFA-60-01'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '11d07b11-0cd4-45be-b42e-4285f2d5b4a7',
      offerId: 'b80bb1fc-1fef-42a3-8432-90b1b429777a',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    //We need to hard code the product pricing if in future price change will happen
    disclaimer: `When you purchase <span>Z Factor</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl:
      'https://m2stage.relieffactor.com/media/catalog/product/r/f/rf-sleep-500.png',
  },
  [DE_ANTIOXIDANTS]: {
    key: DE_ANTIOXIDANTS,
    title: 'Antioxidants with Vitamin C & Bioflavonoids',
    name: 'Antioxidants with Vitamin C & Bioflavonoids (120 count)',
    productName: 'Antioxidants with Vitamin C & Bioflavonoids (120 count)',
    category: 'ACB',
    isSubscription: true,
    displayPrice: 17.5,
    initialPrice: '19.95',
    recurringPrice: '29.95',
    single_price: '19.95',
    sku: 'ACB-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['ACB-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['ACB-120-01'][db],
      quantity: 1,
      planId: 'd2c7d29a-484c-4791-871f-6300060fa02b',
      offerId: '7c5adf23-ef81-4dca-a1b3-b72e3d1f6f48',
    },
    disclaimer: `When you purchase <span>Antioxidants with Vitamin C & Bioflavonoids</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $25.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [DE_ANTIOXIDANTS_SINGLE]: {
    key: DE_ANTIOXIDANTS_SINGLE,
    title: 'Antioxidants with Vitamin C & Bioflavonoids',
    name: 'Antioxidants with Vitamin C & Bioflavonoids (120 count)',
    productName: 'Antioxidants with Vitamin C & Bioflavonoids (120 count)',
    category: 'ACB',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '19.95',
    recurringPrice: '29.95',
    single_price: '22.5',
    sku: 'ACB-120-01',
    productId: mappedProductIDs['ACB-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['ACB-120-01'][db],
      quantity: 1,
      planId: 'd2c7d29a-484c-4791-871f-6300060fa02b',
      offerId: '7c5adf23-ef81-4dca-a1b3-b72e3d1f6f48',
    },
    disclaimer: `When you purchase <span>Antioxidants with Vitamin C & Bioflavonoids</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $25.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_FULL_SPECTRUM_E]: {
    key: RF_FULL_SPECTRUM_E_SINGLE,
    title: 'Full Spectrum E',
    name: 'Full Spectrum E (120 count)',
    productName: 'Full Spectrum E (120 count)',
    category: 'FSE',
    isSubscription: true,
    displayPrice: 19.55,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '37.00',
    sku: 'FSE-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['FSE-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['FSE-120-01'][db],
      quantity: 1,
      planId: '6d9c9293-1d80-4858-a897-bf9659f9b715',
      offerId: '20ea0e29-2d4f-47f5-82dd-dd27735a4817',
    },
    disclaimer: `When you purchase <span>Full Spectrum E</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $42.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_FULL_SPECTRUM_E_SINGLE]: {
    key: RF_FULL_SPECTRUM_E_SINGLE,
    title: 'Full Spectrum E',
    name: 'Full Spectrum E (120 count)',
    productName: 'Full Spectrum E (120 count)',
    category: 'FSE',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '29.95',
    single_price: '37.00',
    sku: 'FSE-120-01',
    productId: mappedProductIDs['FSE-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['FSE-120-01'][db],
      quantity: 1,
      planId: '6d9c9293-1d80-4858-a897-bf9659f9b715',
      offerId: '20ea0e29-2d4f-47f5-82dd-dd27735a4817',
    },
    disclaimer: `When you purchase <span>Full Spectrum E</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $42.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_IMMUNE_FACTOR]: {
    key: RF_IMMUNE_FACTOR,
    title: 'Immune Factors',
    name: 'Immune Factors (120 count)',
    productName: 'Immune Factors (120 count)',
    category: 'IMF',
    isSubscription: true,
    displayPrice: 19.55,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.00',
    sku: 'IMF-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['IMF-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['IMF-120-01'][db],
      quantity: 1,
      planId: 'd47d3651-38b6-4cfe-8f86-a99dab3f3f46',
      offerId: 'de9b7418-a8ca-4f99-968b-98f4f741d11d',
    },
    disclaimer: `When you purchase <span>Immune Factors</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $89.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_IMMUNE_FACTOR_SINGLE]: {
    key: RF_IMMUNE_FACTOR_SINGLE,
    title: 'Immune Factors',
    name: 'Immune Factors (120 count)',
    productName: 'Immune Factors (120 count)',
    category: 'IMF',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'IMF-120-01',
    productId: mappedProductIDs['IMF-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['IMF-120-01'][db],
      quantity: 1,
      planId: 'd47d3651-38b6-4cfe-8f86-a99dab3f3f46',
      offerId: 'de9b7418-a8ca-4f99-968b-98f4f741d11d',
    },
    disclaimer: `When you purchase <span>Immune Factors</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $89.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_N_ACETYL_CYSTEINE]: {
    key: RF_N_ACETYL_CYSTEINE,
    title: 'NAC N-Acetyl L-Cysteine',
    name: 'NAC N-Acetyl L-Cysteine (120 count)',
    productName: 'NAC N-Acetyl L-Cysteine (120 count)',
    category: 'NAC',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.00',
    sku: 'NAC-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['NAC-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['NAC-120-01'][db],
      quantity: 1,
      planId: '269efb0d-f1d6-405f-8899-7644b2e2dd97',
      offerId: 'e239c2da-8ab1-4b1b-b104-52b3f1d165ad',
    },
    disclaimer: `When you purchase <span>NAC N-Acetyl L-Cysteine</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_N_ACETYL_CYSTEINE_SINGLE]: {
    key: RF_N_ACETYL_CYSTEINE_SINGLE,
    title: 'NAC N-Acetyl L-Cysteine',
    name: 'NAC N-Acetyl L-Cysteine (120 count)',
    productName: 'NAC N-Acetyl L-Cysteine (120 count)',
    category: 'NAC',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'NAC-120-01',
    productId: mappedProductIDs['NAC-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['NAC-120-01'][db],
      quantity: 1,
      planId: '269efb0d-f1d6-405f-8899-7644b2e2dd97',
      offerId: 'e239c2da-8ab1-4b1b-b104-52b3f1d165ad',
    },
    disclaimer: `When you purchase <span>NAC N-Acetyl L-Cysteine</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_RED_YEAST_RICE]: {
    key: RF_RED_YEAST_RICE,
    title: 'Red Yeast Rice with CoQ10',
    name: 'Red Yeast Rice with CoQ10 (120 count)',
    productName: 'Red Yeast Rice with CoQ10 (120 count)',
    category: 'RYR',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '44.50',
    sku: 'RYR-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['RYR-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['RYR-120-01'][db],
      quantity: 1,
      planId: 'f9f19f38-8780-45ae-b0a9-28654370744d',
      offerId: 'be436484-7c45-4812-8c36-a626fb7c2565',
    },
    disclaimer: `When you purchase <span>Red Yeast Rice with CoQ10</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $46.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_RED_YEAST_RICE_SINGLE]: {
    key: RF_RED_YEAST_RICE_SINGLE,
    title: 'Red Yeast Rice with CoQ10',
    name: 'Red Yeast Rice with CoQ10 (120 count)',
    productName: 'Red Yeast Rice with CoQ10 (120 count)',
    category: 'RYR',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '44.50',
    sku: 'RYR-120-01',
    productId: mappedProductIDs['RYR-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['RYR-120-01'][db],
      quantity: 1,
      planId: 'f9f19f38-8780-45ae-b0a9-28654370744d',
      offerId: 'be436484-7c45-4812-8c36-a626fb7c2565',
    },
    disclaimer: `When you purchase <span>Red Yeast Rice with CoQ10</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $46.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_BERBERINE]: {
    key: RF_BERBERINE,
    title: 'Berberine',
    name: 'Berberine (60 count)',
    productName: 'Berberine (60 count)',
    category: 'BER',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'BER-60-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['BER-60-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['BER-60-01'][db],
      quantity: 1,
      planId: '66aa5ec3-0e7c-45d7-83e8-3ac6b6e2bf98',
      offerId: '336edfe5-e3e3-44c4-9657-6225f19d856c',
    },
    disclaimer: `When you purchase <span>Berberine</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $32.95 + applicable state taxes each time your supply ships.  To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_BERBERINE_SINGLE]: {
    key: RF_BERBERINE_SINGLE,
    title: 'Berberine',
    name: 'Berberine (60 count)',
    productName: 'Berberine (60 count)',
    category: 'BER',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'BER-60-01',
    productId: mappedProductIDs['BER-60-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['BER-60-01'][db],
      quantity: 1,
      planId: '66aa5ec3-0e7c-45d7-83e8-3ac6b6e2bf98',
      offerId: '336edfe5-e3e3-44c4-9657-6225f19d856c',
    },
    disclaimer: `When you purchase <span>Berberine</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $32.95 + applicable state taxes each time your supply ships.  To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_B_COMPLEX]: {
    key: RF_VITAMIN_B_COMPLEX,
    title: 'Vitamin B Complex',
    name: 'Vitamin B Complex (120 count)',
    productName: 'Vitamin B Complex (120 count)',
    category: 'VBC',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'VBC-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['VBC-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['VBC-120-01'][db],
      quantity: 1,
      planId: '6573caad-3d05-474a-8573-96753d1fc599',
      offerId: 'fdfca5b5-6b9c-46ef-b341-4292b0626c38',
    },
    disclaimer: `When you purchase <span>Vitamin B Complex</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_B_COMPLEX_SINGLE]: {
    key: RF_VITAMIN_B_COMPLEX_SINGLE,
    title: 'Vitamin B Complex',
    name: 'Vitamin B Complex (120 count)',
    productName: 'Vitamin B Complex (120 count)',
    category: 'VBC',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '49.25',
    sku: 'VBC-120-01',
    productId: mappedProductIDs['VBC-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['VBC-120-01'][db],
      quantity: 1,
      planId: '6573caad-3d05-474a-8573-96753d1fc599',
      offerId: 'fdfca5b5-6b9c-46ef-b341-4292b0626c38',
    },
    disclaimer: `When you purchase <span>Vitamin B Complex</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VESSEL_PROTECTION]: {
    key: RF_VESSEL_PROTECTION,
    title: 'Vessel Protection',
    name: 'Vessel Protection (60 count)',
    productName: 'Vessel Protection(60 count)',
    category: 'VEP',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '19.50',
    sku: 'VEP-60-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['VEP-60-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['VEP-60-01'][db],
      quantity: 1,
      planId: 'fe69b935-5c3e-46a4-8cb2-b5aae68ce108',
      offerId: '4a2a06a9-0b5c-4b34-a401-3fd98ba46b0e',
    },
    disclaimer: `When you purchase <span>Vessel Protection</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VESSEL_PROTECTION_SINGLE]: {
    key: RF_VESSEL_PROTECTION_SINGLE,
    title: 'Vessel Protection',
    name: 'Vessel Protection (60 count)',
    productName: 'Vessel Protection (60 count)',
    category: 'VEP',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '19.50',
    sku: 'VEP-60-01',
    productId: mappedProductIDs['VEP-60-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['VEP-60-01'][db],
      quantity: 1,
      planId: 'fe69b935-5c3e-46a4-8cb2-b5aae68ce108',
      offerId: '4a2a06a9-0b5c-4b34-a401-3fd98ba46b0e',
    },
    disclaimer: `When you purchase <span>Vessel Protection</span> you will automatically receive the regular <span>60-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_D_K2]: {
    key: RF_VITAMIN_D_K2,
    title: 'Vitamin D3 and K-2 2000 IU',
    name: 'Vitamin D3 and K-2 2000 IU (120 count)',
    productName: 'Vitamin D3 and K-2 2000 IU (120 count)',
    category: 'DK2',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '11.75',
    sku: 'DK2-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['DK2-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['DK2-120-01'][db],
      quantity: 1,
      planId: '267702c9-cba8-46bb-b04e-7da1261cd41f',
      offerId: '4e44b8c0-579d-4ff7-a581-e4051a6b7962',
    },
    disclaimer: `When you purchase <span>Vitamin D3 and K-2 2000 IU</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $12.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_D_K2_SINGLE]: {
    key: RF_VITAMIN_D_K2_SINGLE,
    title: 'Vitamin D3 and K-2 2000 IU',
    name: 'Vitamin D3 and K-2 2000 IU (120 count)',
    productName: 'Vitamin D3 and K-2 2000 IU (120 count)',
    category: 'DK2',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '11.75',
    sku: 'DK2-120-01',
    productId: mappedProductIDs['DK2-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['DK2-120-01'][db],
      quantity: 1,
      planId: '267702c9-cba8-46bb-b04e-7da1261cd41f',
      offerId: '4e44b8c0-579d-4ff7-a581-e4051a6b7962',
    },
    disclaimer: `When you purchase <span>Vitamin D3 and K-2 2000 IU</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $12.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_D_K5]: {
    key: RF_VITAMIN_D_K5,
    title: 'Vitamin D3 and K-2 5000 IU',
    name: 'Vitamin D3 and K-2 5000 IU (120 count)',
    productName: 'Vitamin D3 and K-2 5000 IU (120 count)',
    category: 'DK5',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '22.20',
    sku: 'DK5-120-01',
    isEligibleForSingleOrder: true,
    productId: mappedProductIDs['DK5-120-01'][db],
    free_products: [],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['DK5-120-01'][db],
      quantity: 1,
      planId: '278c806c-4f6b-4449-a305-f4c6498d2eda',
      offerId: 'd312ccbb-ca76-470d-b131-0955d8bb92d7',
    },
    disclaimer: `When you purchase <span>Vitamin D3 and K-2 5000 IU</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $23.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_VITAMIN_D_K5_SINGLE]: {
    key: RF_VITAMIN_D_K5_SINGLE,
    title: 'Vitamin D3 and K-2 5000 IU',
    name: 'Vitamin D3 and K-2 5000 IU (120 count)',
    productName: 'Vitamin D3 and K-2 5000 IU (120 count)',
    category: 'DK5',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '0.00',
    recurringPrice: '19.95',
    single_price: '22.20',
    sku: 'DK5-120-01',
    productId: mappedProductIDs['DK5-120-01'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['DK5-120-01'][db],
      quantity: 1,
      planId: '278c806c-4f6b-4449-a305-f4c6498d2eda',
      offerId: 'd312ccbb-ca76-470d-b131-0955d8bb92d7',
    },
    disclaimer: `When you purchase <span>Vitamin D3 and K-2 5000 IU</span> you will automatically receive the regular <span>120-capsule</span> supply shipped in 60 days and then every 2 months thereafter unless you cancel. Your card will be charged $23.95 + applicable state taxes each time your supply ships. To cancel, call <a href="tel:+1833-888-1533">833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.`,
    imageUrl: '',
  },
  [RF_RELIEF_FACTOR_QS_NEC]: {
    key: RF_RELIEF_FACTOR_QS_NEC,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: true,
    displayPrice: 19.95,
    initialPrice: '19.95',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-04',
    productId: mappedProductIDs['REL-60-04'][db],
    CA_sku: 'REL-60-05',
    CA_product_id: mappedProductIDs['REL-60-05'][db],
    free_products: [
      {
        sku: 'FREE_VITD',
        name: 'Vitamin D3',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitd.jpg',
        productId: mappedProductIDs['FREE_VITD'][db],
        dsc: '30 softgels',
      },
      {
        sku: 'FREE_VITC',
        name: 'Vitamin C',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitc.jpg',
        productId: mappedProductIDs['FREE_VITC'][db],
        dsc: '30 tablets',
      },
    ],
    maxQty: 2,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['REL-60-04'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'a7b3fcb1-92e4-4b6f-a05e-e8d7f072ca8d',
      triggerType: '3', // Need to check before going to Production
      //      existingItemsOffer: [],
    },
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $84.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_RELIEF_FACTOR_QS_NEC_SINGLE]: {
    key: RF_RELIEF_FACTOR_QS_NEC_SINGLE,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: false,
    displayPrice: 19.95,
    initialPrice: '19.95',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-04',
    productId: mappedProductIDs['REL-60-04'][db],
    CA_sku: 'REL-60-05',
    CA_product_id: mappedProductIDs['REL-60-05'][db],
    free_products: [
      {
        sku: 'FREE_VITD',
        name: 'Vitamin D3',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitd.jpg',
        productId: mappedProductIDs['FREE_VITD'][db],
        dsc: '30 softgels',
      },
      {
        sku: 'FREE_VITC',
        name: 'Vitamin C',
        image_url:
          'https://m2stage.relieffactor.com/media/catalog/product/s/h/shield-vitc.jpg',
        productId: mappedProductIDs['FREE_VITC'][db],
        dsc: '30 tablets',
      },
    ],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Subscribe & Save',
    quoteParams: {
      productId: mappedProductIDs['REL-60-04'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'a7b3fcb1-92e4-4b6f-a05e-e8d7f072ca8d',
      triggerType: '3', // Need to check before going to Production
      //      existingItemsOffer: [],
    },
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $84.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
  [RF_RELIEF_FACTOR_60_CT_NEC]: {
    key: RF_RELIEF_FACTOR_60_CT_NEC,
    title: 'Relief Factor',
    name: 'Relief Factor (60 count)',
    productName: 'Relief Factor (60 count)',
    category: 'REL',
    isSubscription: false,
    displayPrice: 93.95,
    initialPrice: '0.00',
    recurringPrice: '79.95',
    single_price: '93.95',
    sku: 'REL-60-04',
    productId: mappedProductIDs['REL-60-04'][db],
    CA_sku: 'REL-60-05',
    CA_product_id: mappedProductIDs['REL-60-05'][db],
    free_products: [],
    maxQty: 10,
    quantityInfoMsg: 'You have reached maximum quantity',
    purchaseOption: 'Single Purchase',
    quoteParams: {
      productId: mappedProductIDs['REL-60-04'][db],
      //customerId: '',
      quantity: 1,
      //      couponCode: '',
      //      freeProducts: [],
      planId: '98eb55e1-658b-4f2e-a71e-844b093699b1',
      offerId: 'e93a7a6f-82d2-4a4e-8d9d-1bfa02129f36',
      //      triggerType: '',
      //      existingItemsOffer: [],
    },
    disclaimer:
      "When you purchase <span>Relief Factor</span> you will automatically receive a full month’s supply <span>(60 packets)</span> of <span>Relief Factor</span> shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call <a href='tel:+1833-888-1533'>833-888-1533</a> or send an email to <a href='mailto:contactus@relieffactor.com'>contactus@relieffactor.com</a> at least 1 day before your next supply ships.",
    imageUrl:
      'https://m2beta-frontend.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1__2.png',
  },
};

const updateProductPrices = (newProducts, productApiData) => {
  return Object.keys(newProducts).reduce((updatedProducts, productKey) => {
    const productFromApi = productApiData.find((apiProduct) => {
      return (
        apiProduct.offer_id === newProducts[productKey].quoteParams.offerId
      );
    });

    if (productFromApi) {
      updatedProducts[productKey] = {
        ...newProducts[productKey],
        initialPrice: productFromApi.initial_price,
        single_price: productFromApi.single_price,
        recurringPrice: productFromApi.recurring_price,
        isEligibleForSingleOrder: productFromApi.isEligibleForSingleOrder,
      };
    } else {
      updatedProducts[productKey] = newProducts[productKey].quoteParams.offerId;
    }

    return updatedProducts;
  }, {});
};

const updatedNewProducts = updateProductPrices(newProducts, productApiData);
//? Updated products on : 06-09-2023 by Alfred Joseph
const products = {
  ...oldProducts,
  ...updatedNewProducts,
};

export { products, productsKeyConstants, ProductsCategory };
